import {Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';
import {Path} from 'app/shared/path';
import { DataService } from 'app/data.service';

declare let $: any;
@Component({
   selector: 'app-sender-list',
   templateUrl: './sender-list.component.html',
   styleUrls: ['./sender-list.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({height: 0})),
         state('expand', style({height: '*'})),
         transition('collapse => expand', animate('400ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ]
})
export class SenderListComponent {

   @Input() tin: string;
   @Input() parent = '';
   @Input() path = '';
   @Input() parentPath = '';
   @Input() move = false;
   @Input() exportPath = false;
   @Input() select_id: any;
   m = false;
   animationState = 'collapse';
   loading = false;
   error: string;
   selectedItem: any;
   selected: boolean;
   givePath: string;
   @Output() selectPath = new EventEmitter<boolean>();
   @Output() getPath = new EventEmitter<any>();

   constructor(private router: Router, public dataService: DataService) {
   }

   toggle() {
      if (!this.dataService.senderObject.senderList) {
         this.loading = true;
         this.animationState = this.animationState === 'collapse' ? 'expand' : 'collapse';
      } else {
         this.animationState = this.animationState === 'collapse' ? 'expand' : 'collapse';
      }
   }

   isExpanded(): boolean {
      return this.animationState === 'expand';
   }

   getFragment(name: string): string {
      return this.path ? this.path + '/' + name : name;
   }

   navigate(name: string) {
      const url = Path.combine('/tasks/sender', encodeURIComponent(name));
      sessionStorage.setItem('taskPath', url);
      this.router.navigate([url]);
   }

   select(name: any, sub: any) {
      $('.selectedPath').removeClass('selectedPath');
      $('#move' + name.id).addClass('selectedPath');
      if (!sub.isExpanded()) {
         sub.toggle();
      }
      if (this.selectedItem === sub) {
         return;
      }
      if (this.selectedItem) {
         this.selectedItem.selected = false;
      }
      this.selectedItem = sub;
      sub.selected = true;
   }

   onSelectPath(agreed: any) {
      this.selectPath.emit(agreed);
   }

   onGetPath(name) {
      this.getPath.emit(this.parentPath + name);
   }
}
